module.exports = __webpack_public_path__ + "static/media/img-02.3ca51e0c.jpg";